// ResumenSidebar - Sprint 44 Fase 3 Vista 3.
// Panel lateral derecho del form con resumen rapido del producto.
// Reemplaza el <aside> Tailwind hardcoded del legacy por tokens XL.
import { useEffect } from 'react';
import { ensureKeyframes, injectCSS } from '../../../design/motion';
import XLBadge from '../../../components/xl/XLBadge';
import { fmtMoney } from '../../../utils/money';

const CSS_ID = 'xl-prod-resumen-css';
const CSS = `
.xl-prod-res {
  width: 280px;
  flex-shrink: 0;
  background: var(--xl-color-surface);
  border: 1px solid var(--xl-color-border);
  border-radius: var(--xl-radius-lg);
  padding: 16px;
  box-shadow: var(--xl-shadow-sm);
  font-family: var(--xl-font-sans);
}
@media (max-width: 1100px) { .xl-prod-res { width: 100% } }

.xl-prod-res__title {
  font-size: 11px; font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--xl-color-text-muted);
  margin: 0 0 12px;
}
.xl-prod-res__row {
  display: flex; flex-direction: column; gap: 2px;
  margin-bottom: 10px;
}
.xl-prod-res__label {
  font-size: 10px; text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--xl-color-text-muted);
  font-weight: 600;
}
.xl-prod-res__value {
  font-size: 13px;
  color: var(--xl-color-text);
  overflow: hidden;
  text-overflow: ellipsis;
}
.xl-prod-res__mono { font-family: var(--xl-font-mono) }
.xl-prod-res__sep {
  border: 0;
  border-top: 1px solid var(--xl-color-border);
  margin: 12px 0;
}
.xl-prod-res__highlight {
  background: rgba(5,150,105,0.08);
  border: 1px solid rgba(5,150,105,0.28);
  border-radius: var(--xl-radius-md);
  padding: 10px 12px;
}
[data-xl-theme="dark"] .xl-prod-res__highlight {
  background: rgba(16,185,129,0.14);
  border-color: rgba(16,185,129,0.32);
}
.xl-prod-res__highlight .xl-prod-res__label { color: var(--xl-color-success) }
.xl-prod-res__highlight .xl-prod-res__value { color: var(--xl-color-success); font-weight: 600 }
`;

export default function ResumenSidebar({ form }) {
  useEffect(() => { ensureKeyframes(); injectCSS(CSS_ID, CSS); }, []);

  return (
    <aside className="xl-prod-res" aria-label="Resumen del producto">
      <h3 className="xl-prod-res__title">Resumen</h3>

      <div className="xl-prod-res__row">
        <span className="xl-prod-res__label">Codigo</span>
        <span className="xl-prod-res__value xl-prod-res__mono">
          {form.codigo || '\u2014'}
        </span>
      </div>
      <div className="xl-prod-res__row">
        <span className="xl-prod-res__label">Nombre</span>
        <span className="xl-prod-res__value">{form.nombre || '\u2014'}</span>
      </div>
      <div className="xl-prod-res__row">
        <span className="xl-prod-res__label">Categoria</span>
        <span className="xl-prod-res__value">{form.categoria || '\u2014'}</span>
      </div>
      <div className="xl-prod-res__row">
        <span className="xl-prod-res__label">Estado</span>
        <span className="xl-prod-res__value">
          <XLBadge variant={form.is_active ? 'success' : 'neutral'} dot>
            {form.is_active ? 'Activo' : 'Inactivo'}
          </XLBadge>
        </span>
      </div>

      <hr className="xl-prod-res__sep" />

      <div className="xl-prod-res__row">
        <span className="xl-prod-res__label">Precio venta</span>
        <span className="xl-prod-res__value xl-prod-res__mono">
          {form.precio_venta === '' || form.precio_venta == null
            ? '\u2014'
            : fmtMoney(Number(form.precio_venta), 'COP')}
        </span>
      </div>
      <div className="xl-prod-res__row">
        <span className="xl-prod-res__label">Costo ultimo</span>
        <span className="xl-prod-res__value xl-prod-res__mono">
          {form.costo_ultimo === '' || form.costo_ultimo == null
            ? '\u2014'
            : fmtMoney(Number(form.costo_ultimo), 'COP')}
        </span>
      </div>

      <div className="xl-prod-res__row xl-prod-res__highlight">
        <span className="xl-prod-res__label">Costo real (aterrizado)</span>
        <span className="xl-prod-res__value xl-prod-res__mono">
          {form.costo_real == null
            ? '\u2014'
            : fmtMoney(Number(form.costo_real), 'COP')}
        </span>
      </div>
    </aside>
  );
}
